<script>
import TitleImage from "@/components/molecules/title-image";
export default {
  name: "SearchResultNoSuggestion",
  components: {
    TitleImage
  },
  props: {
    categories: {
      type: Array,
      required: true
    }
  }
};
</script>

<template>
  <div>
    <p class="u-font-secondary u-font-24 u-font-700 u-color-primary u-text-center u-mb-lg">
      Découvrez nos rayons
    </p>
    <div
      v-if="categories"
      class="u-flex u-flex-wrap u-flex-justify-center u-gap-sm"
    >
      <TitleImage
        v-for="category in categories"
        :key="category.id"
        :image-path="category.attributes.visuel"
        :image-alt="category.attributes.libelle"
        :slug="category.attributes.slug"
        :radius="'full'"
        border
        class="c-search-result-no-suggestion-mobile__category u-flex-item-fluid"
      >
        <p class="u-font-20 c-search-result-no-suggestion-mobile__category-label">
          {{ category.attributes.libelle }}
        </p>
      </TitleImage>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/search-result-no-suggestion-mobile.scss";
</style>
